'use client';
import { ReactNode, Suspense } from 'react';
import StoreProvider from './StoreProvider';
import GlobalModalHost from '@/components/layout/GlobalModalHost';
import GlobalLoadingOverlay from '@/components/layout/GlobalLoadingOverlay';
import AuthInitializer from './AuthInitializer';
import GlobalLoadingRouteReset from '@/components/layout/GlobalLoadingRouteReset';
import { ExpiryWatcher } from '@/components/auth/ExpiryWatcher';

type Props = { children: ReactNode };

export default function Providers({ children }: Props) {
  return (
    <StoreProvider>
      {/* 初始化 auth state（localStorage → Redux） */}
      <AuthInitializer />

      {/* token過期監控 */}
      <ExpiryWatcher />

      {/* ⭐ 路由切換時重置全域 loading */}
      <Suspense fallback={null}>
        <GlobalLoadingRouteReset />
      </Suspense>

      {children}

      {/* 全域 Modal */}
      <GlobalModalHost />

      {/* 全域 Loading */}
      <GlobalLoadingOverlay />
    </StoreProvider>
  );
}
